<div class="flex-wrap d-flex">
  <ng-container *ngFor="let tab of tabs">
    <button
      *ngIf="!tab.hidden && hasRouterLink(tab)"
      type="button"
      class="rounded-0 btn btn-outline-primary"
      (click)="onTabClick(tab)"
      [ngClass]="[
        buttonClass,
        isTabHighlighted(tab) ? tab.activeClass || 'btnChange' : '',
      ]"
      [class.active]="isTabHighlighted(tab)"
      [value]="tab.value"
      [attr.data-testid]="tab.dataTestId || 'nav-tab-' + tab.value"
      [routerLink]="tab.routerLink"
    >
      <i *ngIf="tab.iconClass" [class]="tab.iconClass"></i>
      <i *ngIf="tab.materialIcon" class="material-icons mr-setting-icon">{{
        tab.materialIcon
      }}</i>
      {{ tab.label | translate }}
    </button>

    <button
      *ngIf="!tab.hidden && !hasRouterLink(tab)"
      type="button"
      class="rounded-0 btn btn-outline-primary"
      (click)="onTabClick(tab)"
      [ngClass]="[
        buttonClass,
        tab.activeCondition ? tab.activeClass || 'btnChange' : '',
      ]"
      [class.active]="tab.activeCondition"
      [value]="tab.value"
      [attr.data-testid]="tab.dataTestId || 'nav-tab-' + tab.value"
    >
      <i *ngIf="tab.iconClass" [class]="tab.iconClass"></i>
      {{ tab.label | translate }}
    </button>
  </ng-container>
</div>
